
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useFormik} from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import CardHeader from "@material-ui/core/CardHeader";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import { createNewDriver, updateDriver } from "../AdminPagesCrud";

function DriverAddEdit({driver, setDriver, supplierId, edit, setEdit, isNew, setIsNew, intl}){

    // const {id} = useParams();

    const {accessToken} = useSelector (
        ({auth}) =>({
            accessToken: auth.authToken,
        })
    )

    useEffect(() => {

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const driverSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(30, "Maximum 30 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const formik = useFormik({
        initialValues: driver,
        validationSchema: driverSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                if(isNew){

                    createNewDriver(values, supplierId, accessToken).then((response) => {
                        setIsNew(!isNew)
                        setDriver({ name : "" })
                        // setShowSnackbar(!showSnackbar)
                    })
                }
                else {
                    updateDriver(driver._id, values, accessToken).then((response) => {
                        setEdit(!edit)
                        setDriver({ name : "" })
                    })
                }

            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }
        },
    });


    return (
        <>
            <Card>
                {edit ? <CardHeader title="Edit Driver"/> : <CardHeader title="New Driver"/> }
                <CardBody>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Driver Name</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="name"
                                                        {...formik.getFieldProps("name")}
                                                    />
                                                    {formik.touched.name && formik.errors.name ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.name}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                                { edit ?
                                    <div className="col-12 row justify-content-center">
                                    
                                        <button className="btn btn-primary" type="submit">
                                            Save
                                        </button>
                                        <div className="pl-4"/>
                                        <button className="btn btn-secondary" type="button" onClick={() => {
                                                setDriver({ name : "" })
                                                setEdit(!edit)
                                            }
                                        }>
                                            Cancel
                                        </button>
                                    </div>
                                    :
                                    <div className="col-12 row justify-content-center">
                                    
                                        <button className="btn btn-primary" type="submit">
                                            Create
                                        </button>
                                        <div className="pl-4"/>
                                        <button className="btn btn-secondary" type="button" onClick={() => {
                                                setDriver({ name : "" })
                                                setIsNew(!isNew)
                                            }
                                        }>
                                            Cancel
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </>
    )
}

export default injectIntl(DriverAddEdit);
